import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Route, Switch } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import SupplierPaymentsIndexPage from '../containers/SupplierPayments'

import appActions from '../redux/app/actions'

const { changeCurrent } = appActions

const SupplierPaymentsPage = ({ location, match }) => {
  const dispatch = useDispatch()
  const current = useSelector(state => state.getIn(['App', 'current'])).toJS()
  const { pathname } = location

  useEffect(() => {
    if (current[0] !== 'supplier_payments') {
      dispatch(changeCurrent(['supplier_payments']))
    }
  }, [pathname])

  const path = match.url

  return (
    <Switch>
      <Route path={`${path}/`} component={SupplierPaymentsIndexPage} exact />
    </Switch>
  )
}

SupplierPaymentsPage.propTypes = {
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
}

export default SupplierPaymentsPage
